import React from 'react';
import { useGame } from '../context/GameContext';
import './TeamSelection.css';

function TeamSelection({ section, sectionTitle, onTeamSelect }) {
  const { teams } = useGame();

  return (
    <div className="team-selection-screen">
      <div className="selection-content">
        <div className="section-header">
          <div className="team-selection-logo-container">
            <img 
              src="/fortuin.gif" 
              alt="Escape Room Logo" 
              className="team-selection-logo-gif"
            />
          </div>
          <h1 className="section-title">{sectionTitle}</h1>
        </div>

        <h2 className="selection-prompt">Select Your Team</h2>

        <div className="teams-grid-selection">
          {teams.map((team) => (
            <button
              key={team._id}
              className="team-button"
              onClick={() => onTeamSelect(team._id)}
            >
              <div className="team-button-content">
                <span className="team-icon">🎯</span>
                <span className="team-name">{team.name}</span>
              </div>
            </button>
          ))}
        </div>

        <p className="instruction-text">
          Tap your team name to begin
        </p>
      </div>
    </div>
  );
}

export default TeamSelection;

